import { render } from "./BaseCard.vue?vue&type=template&id=215f2caf&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=215f2caf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-215f2caf"

export default script